import { defineMessages } from "react-intl";

export const boardBasisMessages = defineMessages({
  AI: { id: "hotels.boardBasis.AI", defaultMessage: "All inclusive" },
  BB: { id: "hotels.boardBasis.BB", defaultMessage: "Bed & breakfast" },
  FB: { id: "hotels.boardBasis.FB", defaultMessage: "Full board" },
  HB: { id: "hotels.boardBasis.HB", defaultMessage: "Half board" },
  RD: { id: "hotels.boardBasis.RD", defaultMessage: "Checkroom available" },
  RO: { id: "hotels.boardBasis.RO", defaultMessage: "1x Room / Room Only" },
  SC: { id: "hotels.boardBasis.SC", defaultMessage: "Self catering" },
});

export function isKnownBoardBasis(
  value: string,
): value is keyof typeof boardBasisMessages {
  return Object.keys(boardBasisMessages).includes(value);
}
